import { SyncAlt as SyncAltIcon } from '@mui/icons-material';

const SyncAlt = (): JSX.Element => <SyncAltIcon fontSize="inherit" />;

export default SyncAlt;
